module.exports = __webpack_public_path__ + "static/img/dip_logo.84ea65f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dip_logo.png
// module id = qVGn
// module chunks = 1